import SectionWrapper from "./sectionWrapper";

export default SectionWrapper;
